import React, { useState, useEffect, useRef } from 'react';
import {IconButton} from "@material-ui/core";
import Alert from '@mui/material/Alert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const CopiarTexto = ({titulo,link})=>{
    const [copiado,setCopiado]=React.useState(false);

    const copiarLink = async ()=>{
        try{
            const copy = await navigator.clipboard.writeText(link);
            setCopiado(true);
            setTimeout(() => {
                    setCopiado(false)
            }, 600);
        }catch(err){
            alert(err)
        }
    }

    return  <div className='mt-2 mb-2 flex'>
    <div>
        <Alert severity="info" variant='outlined'>
                <b>{titulo}</b>
                <div style={{display:'flex',alignItems:'center'}}>
                        <p>{link}</p>
                    </div>
        </Alert>
    </div>
    <div>
        <IconButton title='Copiar el link' onClick={copiarLink}  aria-label="upload picture" component="label">
            <ContentCopyIcon />
        </IconButton>
         {copiado && <p className='color-red text-small'>Link copiado</p>} 
    </div>
</div>
}


 

